import styled from "styled-components";

import Text from "components/atoms/text/Text";

export const PanelCard = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 40px;
    border: 1px solid var(--color-Outline);
    border-radius: 8px;
    background: var(--color-White);
`;

export const PanelHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--color-Outline);
`;

export const PanelHeaderMain = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const PanelTitle = styled(Text)`
    font-size: 1.8rem;
    font-weight: 600;
    color: var(--color-SubBlack);
`;

export const PanelHeaderAside = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
`;

export const IntroDescription = styled(Text)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;

export const FormSectionHeader = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
`;

export const FormSectionTitle = styled(Text)`
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--color-SubBlack);
`;

export const HelperText = styled(Text)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

export const InitialFieldCard = styled.div`
    border: 1px solid
        ${(props) =>
            props.$collapsible
                ? props.$expanded
                    ? "var(--color-Key)"
                    : "var(--color-Outline)"
                : "var(--color-Outline)"};
    border-radius: 10px;
    background: ${(props) => (props.$collapsible ? "var(--color-White)" : "var(--color-Base1)")};
    padding: ${(props) => (props.$collapsible ? "0" : "12px")};
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
    box-shadow: ${(props) => (props.$collapsible && props.$expanded ? "0 2px 8px rgba(15, 23, 42, 0.06)" : "none")};
`;

export const InitialFieldPrompt = styled(Text)`
    margin-bottom: 4px;
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--color-SubBlack);
`;

export const InitialFieldHeader = styled.button`
    width: 100%;
    border: 0;
    background: transparent;
    padding: 10px 12px;
    min-height: 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    text-align: left;
    cursor: pointer;

    ${InitialFieldPrompt} {
        margin-bottom: 0;
    }
`;

export const InitialFieldSummary = styled.div`
    margin-top: 3px;
    font-size: 1.2rem;
    color: var(--color-Grey1);
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const InitialFieldChevron = styled.span`
    font-size: 1.3rem;
    color: var(--color-Grey1);
    transform: ${(props) => (props.$expanded ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease;
`;

export const InitialFieldBody = styled.div`
    border-top: 1px solid var(--color-Outline);
    padding: 8px 12px 10px;
`;

export const QuestionOptionRow = styled.label`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 4px 0;
    cursor: pointer;
`;

export const OptionTextWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const OptionLabel = styled.span`
    font-size: 1.3rem;
    color: var(--color-SubBlack);
`;

export const OptionDescription = styled.span`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

export const InputWrap = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const QueryInput = styled.input`
    flex: 1;
    padding: 10px;
    border: 1px solid var(--color-Outline);
    border-radius: 4px;
    font-size: 1.4rem;
    color: var(--color-SubBlack);
    outline: none;
    height: 44px;

    &::placeholder {
        color: var(--color-Grey2);
    }

    &:focus {
        border-color: var(--color-Key);
        box-shadow: 0 0 0 3px rgba(0, 154, 126, 0.12);
    }
`;

export const InlineInputRow = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 8px;
`;

export const InlineInput = styled.input`
    flex: 1;
    height: 36px;
    border: 1px solid var(--color-Outline);
    border-radius: 6px;
    padding: 0 10px;
    outline: none;
    font-size: 1.3rem;
`;

export const StatusRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

export const ActionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-top: 4px;
`;

export const ActionGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ProgressNote = styled.div`
    border: 1px solid #bae6fd;
    border-radius: 8px;
    background: #f0f9ff;
    padding: 10px 12px;
    font-size: 1.3rem;
    line-height: 1.5;
    color: #075985;
`;

export const PhaseBadge = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 1.2rem;
    font-weight: 600;
    background: ${(props) => (props.kind === "error" ? "#fee2e2" : props.kind === "done" ? "#dcfce7" : "#fef3c7")};
    color: ${(props) => (props.kind === "error" ? "#991b1b" : props.kind === "done" ? "#166534" : "#92400e")};
`;

export const ReportBox = styled.div`
    border: 1px solid var(--color-Outline);
    border-radius: 8px;
    background: var(--color-Base1);
    padding: 16px;
    white-space: pre-wrap;
    line-height: 1.5;

    font-size: 1.4rem;
    color: var(--color-SubBlack);
`;

export const ResultContentGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 16px;
    align-items: flex-start;

    @media (max-width: 1120px) {
        grid-template-columns: 1fr;
    }
`;

export const ReportMainColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
`;

export const HtmlReportBox = styled.div`
    border: 1px solid var(--color-Outline);
    border-radius: 8px;
    background: var(--color-White);
    padding: 28px 32px;
    font-size: 1.4rem;
    color: var(--color-SubBlack);
    line-height: 1.75;

    > *:first-child {
        margin-top: 0;
    }

    > *:last-child {
        margin-bottom: 0;
    }

    h1,
    h2,
    h3,
    h4 {
        color: var(--color-Black);
        line-height: 1.35;
        letter-spacing: 0;
    }

    h1 {
        margin: 0 0 24px;
        padding-bottom: 14px;
        border-bottom: 1px solid var(--color-Outline);
        font-size: 2.4rem;
        font-weight: 700;
    }

    h2 {
        margin: 34px 0 14px;
        padding-top: 6px;
        font-size: 2rem;
        font-weight: 700;
    }

    h3 {
        margin: 26px 0 10px;
        font-size: 1.7rem;
        font-weight: 700;
    }

    h4 {
        margin: 22px 0 8px;
        font-size: 1.5rem;
        font-weight: 700;
    }

    p {
        margin: 0 0 16px;
    }

    strong {
        font-weight: 700;
        color: var(--color-Black);
    }

    ul,
    ol {
        margin: 0 0 18px 0;
        padding-left: 22px;
    }

    li {
        margin: 6px 0;
        padding-left: 2px;
    }

    li > p {
        margin: 6px 0;
    }

    blockquote {
        margin: 18px 0;
        padding: 12px 16px;
        border-left: 3px solid var(--color-Key);
        border-radius: 0 6px 6px 0;
        background: var(--color-Base1);
        color: var(--color-Grey1);
    }

    hr {
        margin: 28px 0;
        border: 0;
        border-top: 1px solid var(--color-Outline);
    }

    a {
        color: var(--color-Key);
        text-decoration: none;
        font-weight: 600;
    }

    a:hover {
        text-decoration: underline;
    }

    table {
        width: 100%;
        margin: 18px 0 24px;
        border-collapse: collapse;
        border: 1px solid var(--color-Outline);
        border-radius: 8px;
        overflow: hidden;
        font-size: 1.3rem;
    }

    th,
    td {
        border: 1px solid var(--color-Outline);
        padding: 10px 12px;
        text-align: left;
        vertical-align: top;
    }

    th {
        background: var(--color-Base1);
        font-weight: 700;
        color: var(--color-Black);
    }

    code {
        border-radius: 4px;
        background: var(--color-Base1);
        padding: 2px 5px;
        font-size: 1.25rem;
        color: var(--color-SubBlack);
    }

    pre {
        margin: 18px 0;
        border-radius: 8px;
        background: #111827;
        padding: 14px 16px;
        overflow-x: auto;
        color: var(--color-White);
    }

    pre code {
        background: transparent;
        padding: 0;
        color: inherit;
    }
`;

export const SourceAside = styled.aside`
    position: sticky;
    top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: calc(100vh - 180px);
    min-width: 0;
    border: 1px solid var(--color-Outline);
    border-radius: 8px;
    background: var(--color-White);
    padding: 14px;

    @media (max-width: 1120px) {
        position: static;
        max-height: none;
    }
`;

export const SourceAsideHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--color-Outline);
`;

export const SourceAsideTitle = styled(Text)`
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--color-SubBlack);
`;

export const SourceAsideEmpty = styled.div`
    border-radius: 6px;
    background: var(--color-Base1);
    padding: 12px;
    font-size: 1.2rem;
    line-height: 1.5;
    color: var(--color-Grey1);
`;

export const SourceList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 4px;
    overflow-y: auto;
`;

export const SourceTitleText = styled(Text)`
    font-size: 1.4rem;
    line-height: 1.45;
    font-weight: 500;
    color: var(--color-Black);
    transition: color 120ms ease-in;
`;

export const SourceItem = styled.a`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-decoration: none;
    padding: 10px 0;
    border-bottom: 1px solid var(--color-Line);
    color: inherit;
    background: var(--color-White);

    &:last-child {
        border-bottom: 0;
    }

    &:hover {
        ${SourceTitleText} {
            color: var(--color-Key);
        }
    }
`;

export const SourceActionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 4px;
`;

export const SourceLinkText = styled.span`
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--color-Grey1);
`;

export const SourceMetaRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;

    span {
        min-width: 0;
        line-height: 1.45;
        word-break: keep-all;
        overflow-wrap: anywhere;
    }
`;

export const SourceBadge = styled.span`
    display: inline-flex;
    align-items: center;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.2;
    background: #7fb5ad;
    color: var(--color-White);
`;

export const LogItem = styled.div`
    border-radius: 8px;
    background: var(--color-White);
    border: 1px solid #e5e7eb;
    padding: 10px;
`;

export const LogStage = styled.div`
    font-size: 1.1rem;
    font-weight: 700;
    color: #0369a1;
    margin-bottom: 4px;
`;

export const LogMessage = styled.div`
    font-size: 1.2rem;
    color: var(--color-SubBlack);
`;

export const LogMeta = styled.div`
    margin-top: 6px;
    font-size: 1.1rem;
    color: var(--color-Grey1);
    white-space: pre-wrap;
`;

export const LogAccordionCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #f8fafc;
    overflow: hidden;
`;

export const LogAccordionHeader = styled.button`
    width: 100%;
    border: 0;
    background: transparent;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    text-align: left;
    cursor: pointer;
`;

export const LogAccordionTitle = styled.div`
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--color-SubBlack);
`;

export const LogAccordionSummary = styled.div`
    margin-top: 3px;
    font-size: 1.2rem;
    color: var(--color-Grey1);
    line-height: 1.4;
`;

export const LogAccordionChevron = styled.span`
    font-size: 1.3rem;
    color: var(--color-Grey1);
    transform: ${(props) => (props.$expanded ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease;
`;

export const LogAccordionBody = styled.div`
    border-top: 1px solid #e2e8f0;
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ErrorText = styled(Text)`
    border: 1px solid #fecaca;
    border-radius: 8px;
    background: #fef2f2;
    padding: 10px 12px;
    font-size: 1.2rem;
    color: #dc2626;
`;
